import { render, staticRenderFns } from "./ClocksValues.vue?vue&type=template&id=5203adaf&scoped=true&"
import script from "./ClocksValues.vue?vue&type=script&lang=js&"
export * from "./ClocksValues.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5203adaf",
  null
  
)

export default component.exports